module.exports = __webpack_public_path__ + "ni.76a6401d3fa9dc00d562.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/1x1/ni.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/1x1/ni.svg
// module chunks = styles